import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import './pages/admin-promotions-calendar/calendar-styles.css';

// Development tools
if (import.meta.env?.DEV) {
  import('./utils/supabaseDevTest');
}

const container = document.getElementById("root");
const root = ReactDOM?.createRoot(container);

root.render(<App />);
